const firstNames = [
'David',
'John',
'Paul',
'Mark',
'James',
'Andrew',
'Scott',
'Steven',
'Robert',
'Stephen',
'William',
'Craig',
'Michael',
'Stuart',
'Christopher',
'Alan',
'Colin',
'Brian',
'Kevin',
'Gary',
'Richard',
'Derek',
'Martin',
'Thomas',
'Neil',
'Barry',
'Ian',
'Jason',
'Iain',
'Gordon',
'Alexander',
'Graeme',
'Peter',
'Darren',
'Graham',
'George',
'Kenneth',
'Allan',
'Simon',
'Douglas',
'Keith',
'Lee',
'Anthony',
'Grant',
'Ross',
'Jonathan',
'Gavin',
'Nicholas',
'Joseph',
'Stewart',
'Daniel',
'Edward',
'Matthew',
'Donald',
'Fraser',
'Garry',
'Malcolm',
'Charles',
'Duncan',
'Alistair',
'Raymond',
'Philip',
'Ronald',
'Ewan',
'Ryan',
'Francis',
'Bruce',
'Patrick',
'Alastair',
'Bryan',
'Marc',
'Jamie',
'Hugh',
'Euan',
'Gerard',
'Sean',
'Wayne',
'Adam',
'Calum',
'Alasdair',
'Robin',
'Greig',
'Angus',
'Russell',
'Cameron',
'Roderick',
'Norman',
'Murray',
'Gareth',
'Dean',
'Eric',
'Adrian',
'Gregor',
'Samuel',
'Gerald',
'Henry',
'Justin',
'Benjamin',
'Shaun',
'Callum',
'Campbell',
'Frank',
'Roy',
'Timothy',
'Glen',
'Marcus',
'Hamish',
'Niall',
'Barrie',
'Liam',
'Brendan',
'Terence',
'Greg',
'Leslie',
'Lindsay',
'Trevor',
'Vincent',
'Christian',
'Lewis',
'Rory',
'Antony',
'Fergus',
'Roger',
'Arthur',
'Dominic',
'Ewen',
'Jon',
'Owen',
'Gregory',
'Jeffrey',
'Terry',
'Damian',
'Geoffrey',
'Harry',
'Walter',
'Bernard',
'Desmond',
'Jack',
'Aaron',
'Archibald',
'Blair',
'Jeremy',
'Nathan',
'Alister',
'Dale',
'Dylan',
'Glenn',
'Julian',
'Leon',
'Allen',
'Martyn',
'Nigel',
'Alisdair',
'Denis',
'Drew',
'Evan',
'Phillip',
'Frazer',
'Guy',
'Laurence',
'Lawrence',
'Magnus',
'Crawford',
'Finlay',
'Frederick',
'Gregg',
'Karl',
'Kerr',
'Mohammed',
'Rodney',
'Victor',
'Carl',
'Daryl',
'Don',
'Edwin',
'Erik',
'Grahame',
'Ivan',
'Kyle',
'Leigh',
'Lorne',
'Maurice',
'Murdo',
'Nicolas',
'Steve',
'Allister',
'Clark',
'Darran',
'Dennis',
'Elliot',
'Leonard',
'Nairn',
'Scot',
'Stefan',
'Toby',
'Warren',
'Billy',
'Clive',
'Damien',
'Louis',
'Mohammad',
'Neill',
'Noel',
'Ralph',
'Sandy',
'Albert',
'Alun',
'Brett',
'Clifford',
'Eoin',
'Glyn',
'Imran',
'Ivor',
'Johnathan',
'Kevan',
'Neal',
'Oliver',
'Robbie',
'Roland',
'Stanley',
'Aidan',
'Antonio',
'Austin',
'Bradley',
'Cornelius',
'Darrin',
'Derrick',
'Innes',
'Kristian',
'Lachlan',
'Mathew',
'Moray',
'Nicol',
'Shane',
'Tony',
'Brent',
'Findlay',
'Forbes',
'Gilbert',
'Giles',
'Jay',
'Kelvin',
'Leighton',
'Marco',
'Omar',
'Roddy',
'Tom',
'Abdul',
'Alfred',
'Alick',
'Ashley',
'Bryce',
'Conrad',
'Darryl',
'Eugene',
'Harold',
'Harvey',
'Hector',
'Jody',
'Kieran',
'Kirk',
'Kris',
'Marshall',
'Muhammad',
'Ramsay',
'Ray',
'Rodger',
'Seumas',
'Tommy',
'Wai',
'Alex',
'Ali',
'Andrea',
'Archie',
'Daren',
'Derick',
'Gideon',
'Jan',
'Juan',
'Kerry',
'Kieron',
'Luke',
'Lyall',
'Manus',
'Marvin',
'Morgan',
'Muir',
'Myles',
'Ronnie',
'Rowan',
'Rupert',
'Spencer',
'Stephan',
'Struan',
'Torquil',
'Wallace',
'Aftab',
'Alain',
'Alec',
'Alvin',
'Anton',
'Arran',
'Arron',
'Austen',
'Aynsley',
'Benedict',
'Chad',
'Chun',
'Clarke',
'Damon',
'Danny',
'Darron',
'Declan',
'Deryck',
'Edmond',
'Edmund',
'Jacob',
'Johnston',
'Keiron',
'Kennedy',
'Khalil',
'Kristofer',
'Laurie',
'Lloyd',
'Mario',
]

const topics = [
	'Noise Pollution',
	'Patriotism',
	'Health',
	'Corruption',
	'Environment Pollution',
	'Women Empowerment',
	'Music',
	'Time and Tide Wait for none',
	'Science',
	'Science and Technology',
	'Importance of Sports',
	'Sports and Games',
	'Sports',
	'Time Management',
	'Cleanliness is next to Godliness',
	'Cleanliness',
	'Rome was not Built in a Day',
	'Earthquake',
	'Football',
	'Happiness',
	'Success',
	'Unemployment',
	'Clean India',
	'Describe Yourself',
	'Elephant',
	'Festivals Of India',
	'Forest',
	'Ganesh Chaturthi',
	'Healthy Food',
	'Importance Of Water',
	'Junk Food',
	'GST',
	'Plastic Pollution',
	'Fashion',
	'Books',
	'Doctor',
	'Population',
	'Value of Time',
	'Honesty is the Best Policy',
	'Peacock',
	'Gandhi Jayanti',
	'Freedom',
	'Human Rights',
	'Knowledge Is Power',
	'Same Sex Marriage',
	'Childhood Memories',
	'Cyber Crime',
	'Politics',
	'Time',
	'Yoga',
	'Farmer',
	'Food',
	'Kalpana Chawla',
	'Punctuality',
	'Rani Lakshmi Baiv',
	'Role Model',
	'Spring Season',
	'Tourism',
	'Unity In Diversity',
	'Artificial Intelligence',
	'Online Shopping',
	'Respect',
	'Indian Culture',
	'Yoga',
	'Election',
	'Postman',
	'Healthy Lifestyle',
	'Time',
	'Holiday',
	'Indian Education System',
	'Childhood',
	'Disaster Management',
	'Environmental Issues',
	'Freedom Fighters',
	'Garden',
	'Grandparents',
	'Save Fuel For Better Environment',
	'Importance Of Newspaper',
	'Lal Bahadur Shastri',
	'Raksha Bandhan',
	'Teamwork',
	'World Environment Day',
	'Badminton',
	'Narendra Modi',
	'Honesty',
	'What Is Religion',
	'Charity Begins at Home',
	'Money',
	'Swachh Bharat Abhiyan',
	'A Journey by Train',
	'Ideal student',
	'Save Water Save Earth',
	'World Environment Day',
	'Recycling',
	'Disaster Managementv',
	'Indian Farmer',
	'Safety of Women in India',
	'Sarvepalli Radhakrishnan',
	'Capital Punishment',
	'College Life',
	'Natural Resources',
	'Peer Pressure',
	'Motivation',
	'Nature Vs Nurture',
	'Romeo And Juliet',
	'Generation Gap',
	'Makar Sankranti',
	'Constitution of India',
	'Girl Education',
	'Importance of Family',
	'Importance of Independence Day',
	'Natural Resources',
	'Brain Drain',
	'A Friend In Need Is A Friend Indeed',
	'Action Speaks Louder Than Words',
	'All That Glitters Is Not Gold',
	'Bhagat Singh',
	'Demonetization',
	'Agriculture',
	'Cricket',
	'Hockey',
	'Discipline',
	'Importance of Discipline',
	'Parrot',
	'Population Explosion',
	'Poverty',
	'Poverty in India',
	'Uses Of Mobile Phones',
	'Water Scarcity',
	'Train Journey',
	'Land Pollution',
	'Environment Protection',
	'Indian Army',
	'Agriculture',
	'Uses of Internet',
	'Zoo',
	'All that Glitters is not Gold',
	'Balanced Diet',
	'Blood Donation',
	'Digital India',
	'Energy Conservation',
	'National Integration',
	'Railway Station',
	'Sachin Tendulkar',
	'Tsunami',
	'Health And Hygiene',
	'Importance Of Forest',
	'Indira Gandhi',
	'Laughter Is The Best Medicine',
	'Basketball',
	'Career Goals',
	'Marriage',
	'Mental Health',
	'Save Water Save Life',
	'International Yoga Day',
	'Vacation',
	'Gardening',
	'Winter Vacation',
	'Patriotism',
	'Soil Pollution',
	'Criticism',
	'India Gate',
	'Every Cloud Has A Silver Lining',
	'Indian Culture And Tradition',
	'Unity Is Strength',
	'Unity is Diversity',
	'Wildlife Conservation',
	'Cruelty To Animals',
	'Google',
	'Nelson Mandela',
	'Of Mice And Men',
	'Organ Donation',
	'Life in a Big City',
	'Ethics',
	'Democracy in India',
	'Drought',
	'Career',
	'India Gate',
	'Waste Management',
	'Biodiversity',
	'Afforestation',
	'Aryabhatta',
	'Female Foeticide',
	'Harmful Effects Of Junk Food',
	'Rain Water Harvesting',
	'Save Electricity',
	'Social Media',
	'Social Networking Sites',
	'Sound Pollution',
	'Integrity',
	'Procrastination',
	'Life in an Indian Village',
	'Life in Big City',
	'Population Growth',
	'Cancer',
	'World Population Day',
	'Greenhouse Effect',
	'Statue of Unity',
	'Traffic Jam',
	'Female Foeticide',
	'Beti Bachao Beti Padhao',
	'Importance of Good Manners',
	'Good Manners',
	'Red Fort',
	'Unity',
	'Cyber Security',
	'Green Revolution',
	'Health And Fitness',
	'India',
	'Incredible India',
	'Make In India',
	'Save Tiger',
	'Surgical Strike',
	'Triple Talaq',
	'A Good Friend',
	'Importance of Friends in our Life',
	'Youth',
	'Should Plastic be Banned',
	'Nationalism',
	'Knowledge',
	'Traffic Rules',
	'Effects of Global Warming',
	'Labour Day',
	'Fundamental Rights',
	'Diabetes',
	'Values',
	'Solar System',
	'Effects of Global Warming',
	'National Constitution Day',
	'Good Mother',
	'Mother',
	'Secularism',
	'Importance of Trees in our Life',
	'City Life Vs Village Life',
	'Importance of Communication',
	'Conservation of Nature',
	'Man vs. Machine',
	'Indian Economy',
	'Mothers',
	'Mothers Love',
	'Importance of National Integration',
	'Black Money',
]

const exportedObj = { names: firstNames, topics }

export default exportedObj
